import { typographyStyles, constants } from "@newsela/angelou";

const { ui } = constants.colors;
const { heading4Obj } = typographyStyles;

export const titleCss = {
  ...heading4Obj,
  marginBottom: 8,
};

export const linkCss = {
  color: ui.core[700],
};
